export default __webpack_public_path__ + "static/media/LogoTVET.f3f57110.png";